import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import vClickOutside from "v-click-outside";
import store from "./vuex/store";
import xes from "xes-code-base/lib/libs/xes";
// import VConsole from "vconsole";
import Toast from "@/components/Toast/index.js";
import XesLogger from "./utils/logger";
import { XpadBridgeSdk } from "@xes/xpad-bridge-sdk";

import { isXpad } from "./utils";
if (!window.logger) {
  var logger = new XesLogger();
  window.logger = logger;
}

Vue.use(Toast);

// var vlog = new VConsole();
// console.log(vlog);
Vue.use(vClickOutside);
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;
if (isXpad()) {
  router.beforeEach((route, redirect, next) => {
    if (route.path.indexOf("/list") > -1) {
      console.log("[指法训练列表]");
      if (window.XpadBridgeSdk) {
        window.XpadBridgeSdk.closeAutoLog();
      }
      window.XpadBridgeSdk = new XpadBridgeSdk({
        autoLog: false,
        resourceName: "指法训练列表",
      });
      window.XpadBridgeSdk.setHeader("darkness");
    } else if (route.path.indexOf("/video") > -1) {
      console.log("[指法视频]");
      if (window.XpadBridgeSdk) {
        window.XpadBridgeSdk.closeAutoLog();
      }
      window.XpadBridgeSdk = new XpadBridgeSdk({
        autoLog: false,
        resourceId: route.params.id,
        resourceName: "指法视频",
      });
      window.XpadBridgeSdk.setHeader("light");
    } else if (route.path.indexOf("/finger") > -1) {
      console.log("[指法训练]");
      if (window.XpadBridgeSdk) {
        window.XpadBridgeSdk.closeAutoLog();
      }
      window.XpadBridgeSdk = new XpadBridgeSdk({
        resourceId: route.params.id,
        resourceName: "指法训练",
      });
      window.XpadBridgeSdk.setHeader("light");
    } else if (route.path.indexOf("/game") > -1) {
      console.log("[指法游戏]");
      if (window.XpadBridgeSdk) {
        window.XpadBridgeSdk.closeAutoLog();
      }
      window.XpadBridgeSdk = new XpadBridgeSdk({
        resourceId: route.params.id,
        resourceName: "趣味指法练习",
      });
      window.XpadBridgeSdk.setHeader("light");
    }
    next();
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
